module.exports = __webpack_public_path__ + "img/dp-xx-banner1.43e18bf6.png";